export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Mechanical Engineer | London',
    'I finally understand the complete picture of mechanical engineering—from fundamentals through materials, design, thermodynamics, manufacturing, and industrial machinery. This resource transformed how I approach engineering projects professionally.',
  ],
  [
    'JW',
    'Jennifer W.',
    'Industrial Technician | Dublin',
    'I know exactly how to explain mechanical design principles, material selection, machinery operation, thermodynamic concepts, and equipment reliability. This resource does the heavy lifting for me.',
  ],
  [
    'NC',
    'Nora C.',
    'Engineering Specialist | Amsterdam',
    'The technical depth saves me countless hours. The integrated examples are organized step-by-step. I never struggle with technical explanations anymore.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Mechanical Professional',
    "Engineering fundamentals and mechanical design completely changed how I understand machinery systems. It's the clearest technical resource I've found.",
  ],
  [
    'JW',
    'Jennifer W.',
    'Industrial Technician',
    'The formula reference and materials selection guide alone are worth the price. I never struggle with technical calculations or material decisions anymore. Everything is organized and accessible.',
  ],
  [
    'MS',
    'Martin S.',
    'Engineering Specialist',
    'The 30 worked examples and manufacturing process explanations were eye-opening. I can now explain mechanical design principles, equipment operation, thermodynamic concepts, and failure analysis across pumps, gearboxes, turbines, and production systems. This transformed my professional credibility.',
  ],
];
